<div class="sidebar-menu" #menu role="dialog" aria-modal="true" *transloco="let t;">
  <nav class="sidebar-navigation" [attr.aria-label]="'Sidebar Navigation'">
      <cwo-header-navigational-button [label]="t('header.menu')" [target]="storeIdService.getRoutePathSegments(['menu'])"></cwo-header-navigational-button>
    @if(headerFeaturedContentLinks.length) {
      @for (featuredContent of headerFeaturedContentLinks; track $index) {
        @for (featuredItem of featuredContent.featuredItems; track $index) {
          <cwo-header-navigational-button [label]="featuredItem.title ?? ''" [link]="featuredItem?.link ?? ''"></cwo-header-navigational-button>
        }
      }
    }
    <cwo-header-navigational-button [label]="t('header.my_orders')" [target]="storeIdService.getRoutePathSegments(['account', 'my-orders'])"></cwo-header-navigational-button>
    @if(!!configState().store!.hasLoyalty && !configState().store!.hasThirdPartyLoyalty){
      <cwo-header-navigational-button [label]="configService.loyaltyState()?.loyaltyPlanName ?? t('header.rewards')" [target]="storeIdService.getRoutePathSegments(['loyalty'])"></cwo-header-navigational-button>
      @if(premiumService.subscriptions().length) {
        <cwo-header-navigational-button [label]="t('header.premium')" [target]="storeIdService.getRoutePathSegments(['premium'])"></cwo-header-navigational-button>
      }
    }
  </nav>
  <button class="button-undecorated signing-button" (click)="toggleLoggedIn()">{{isLoggedIn() ? 'SIGN OUT': 'SIGN IN'}}</button>

  @if(configState().store?.hasStoreChooser || configState().store?.phone) {
    <div class="store-section" role="region" [attr.aria-label]="t('header.store')">
      @if(configState().store?.hasStoreChooser) {
        <div class="store-section-title">
          <span>{{ t('header.store') }}</span>
          <button class="button-undecorated" [attr.aria-label]="t('header.edit_store_aria_label')" (click)="openStoreSelectionModal()">
            <cwo-icon [name]="iconName.edit" class="icon circled" aria-hidden="true" />
          </button>
        </div>
      }
      <div class="store-section-location">
        <cwo-icon [name]="iconName.store" class="store-section-store-icon" aria-hidden="true" />
        <span>{{ configState().store?.address }}</span>
      </div>
      @if(configState().store?.phone) {
        <a [href]="'tel:' + configState().store?.phone" class="store-section-phone">{{ configState().store?.phone }}</a>
      }
    </div>
  }
</div>